import React, { useState } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ItemToReturn } from '@src/models/returns';
import { useReturnStore } from '@src/stores/returnStore';
import ItemImage from '../shared/items/ItemImage';
import ItemDescription from '../shared/items/ItemDescription';
import EditItemDrawer from './drawer/EditItemDrawer';
import { OptionsDropdown } from '../shared/OptionsDropdown';

interface ReviewItemDetailsProps {
  item: ItemToReturn;
  index: number;
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isEditSubmitting: boolean;
}

const ReviewItemDetails = ({
  item,
  index,
  onEditItemSubmit,
  onRemoveItemSubmit,
  isEditSubmitting,
}: ReviewItemDetailsProps) => {
  const [displayEditDrawer, setDisplayEditDrawer] = useState(false);
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const itemToEdit = selectedItems.find(
    (lineItem) => lineItem.lineItemId === item.lineItemId,
  );

  const onClickEdit = () => setDisplayEditDrawer(true);
  const onClickRemove = () => onRemoveItemSubmit(item.lineItemId);

  const itemOptions = [
    {
      value: 'Edit',
      onClick: onClickEdit,
    },
    {
      value: 'Remove',
      onClick: onClickRemove,
    },
  ];

  return (
    <>
      <div key={`${item.lineItemId}-${index}`} className="sui-flex sui-w-full">
        {/* Product Image */}
        <ItemImage
          imageUrl={item.itemImageURL}
          itemDescription={item.itemDescription}
        />
        <div className="sui-flex sui-flex-col">
          <ItemDescription
            brandName={item.brandName}
            itemDescription={item.itemDescription}
          />
          <div className="sui-text-xs sui-mt-2 sui-mx-[16px] sui-opacity-80">
            <Typography>
              Qty: {item.returnQuantity} | ${item.itemCost?.toFixed(2)} /item
            </Typography>
          </div>
          {itemToEdit && (
            <EditItemDrawer
              displayDrawer={displayEditDrawer}
              closeDrawer={() => setDisplayEditDrawer(false)}
              item={itemToEdit}
              onEditItemSubmit={onEditItemSubmit}
              isEditSubmitting={isEditSubmitting}
            />
          )}
        </div>
        <div className="sui-ml-auto sui-text-right">
          <OptionsDropdown
            label={`Edit-item-${item.lineItemId}`}
            options={itemOptions}
            // Held shut while a change is being submitted. Its options open the
            // drawer and the remove modal, either of which would start a second
            // three-call sequence over the one already running — and the two
            // would interleave, because nothing serialises the sequence as a
            // whole, only the individual calls.
            disabled={isEditSubmitting}
          />
        </div>
      </div>
    </>
  );
};

export default ReviewItemDetails;
